import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { staffApi } from '../../lib/http';
import { PortalButton, PortalCard, PortalInput } from '../../components/portal/PortalElements';

export default function StaffLogin() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    staffApi
      .get('/staff/auth/me')
      .then(() => navigate('/staff/dashboard', { replace: true }))
      .catch(() => undefined);
  }, [navigate]);

  async function handleSubmit(event) {
    event.preventDefault();
    setLoading(true);
    setError('');

    try {
      await staffApi.post('/staff/auth/login', { username, password });
      await staffApi.get('/staff/auth/me');
      toast.success('Staff session started.');
      navigate(params.get('redirect') || '/staff/dashboard', { replace: true });
    } catch (requestError) {
      setError(
        requestError.response?.status === 401
          ? 'Invalid staff credentials.'
          : requestError.message || 'Unable to sign in right now.',
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="portal-login-page">
      <PortalCard className="portal-login-card">
        <p className="portal-kicker">Staff access</p>
        <h2>Sign in to the staff portal</h2>
        {/* <p>Use the same hosted backend session flow that the Nest staff module expects.</p> */}
        <form className="portal-form" onSubmit={handleSubmit}>
          <PortalInput
            label="Username"
            value={username}
            onChange={(event) => setUsername(event.target.value)}
            placeholder="staff username"
            required
          />
          <PortalInput
            label="Password"
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            placeholder="Password"
            required
          />
          {error ? <div className="portal-error">{error}</div> : null}
          <PortalButton type="submit" disabled={loading}>
            {loading ? 'Signing in...' : 'Login'}
          </PortalButton>
        </form>
      </PortalCard>
    </main>
  );
}
